export const storyblokAccessToken = process.env.STORYBLOK_ACCESS_TOKEN || '4lJaoe9ENeiAHpWwoxa7YQtt'